import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
/**
 *
 * @param {{
 *  title: string
 *  children: React.ReactNode
 * }} props
 * @returns
 */ export var SubscriptionSection = function(props) {
    return(// TODO: don't use order-section here, make a more common class
    /*#__PURE__*/ _jsxs("div", {
        className: "order-section-new subscription-section-wrapper",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "title",
                children: props.title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "items-container",
                children: props.children
            })
        ]
    }));
};
var mapStateToProps = function(state) {
    return {};
};
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionSection);
